(function () {
  var LOG = '[Consent]';

  function applyShopifyConsent(granted) {
    console.log(LOG, 'applyShopifyConsent called, granted =', granted);

    if (window.Shopify && window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.setTrackingConsent) {
      console.log(LOG, 'Using modern customerPrivacy API');
      window.Shopify.customerPrivacy.setTrackingConsent(
        { analytics: granted, marketing: granted, preferences: granted, sale_of_data: false },
        function () {
          console.log(LOG, 'setTrackingConsent callback fired');
        }
      );
    } else {
      console.warn(LOG, 'Modern customerPrivacy API not available', {
        Shopify: !!window.Shopify,
        customerPrivacy: !!(window.Shopify && window.Shopify.customerPrivacy),
        setTrackingConsent: !!(window.Shopify && window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.setTrackingConsent),
      });
    }

    if (window.Shopify && window.Shopify.trackingConsent && window.Shopify.trackingConsent.setTrackingConsent) {
      console.log(LOG, 'Using legacy trackingConsent API');
      window.Shopify.trackingConsent.setTrackingConsent(granted);
    } else {
      console.log(LOG, 'Legacy trackingConsent API not available (expected on modern Shopify)');
    }
  }

  function resolveConsent(Didomi) {
    var status = Didomi.getUserConsentStatusForAll ? Didomi.getUserConsentStatusForAll() : null;
    console.log(LOG, 'resolveConsent called, status =', status);

    // Didomi can return a string ('allow'/'deny'/'mixed') or an object ({purposes, vendors})
    if (typeof status === 'string') {
      if (status === 'allow') {
        applyShopifyConsent(true);
      } else if (status === 'deny') {
        applyShopifyConsent(false);
      } else {
        console.log(LOG, 'Status is "' + status + '" — wachten op gebruikerskeuze, geen actie ondernomen');
      }
    } else if (status && typeof status === 'object') {
      var purposes = status.purposes || {};
      var noneDisabled = !purposes.disabled || purposes.disabled.length === 0;
      var someEnabled = purposes.enabled && purposes.enabled.length > 0;
      var granted = noneDisabled && someEnabled;
      console.log(LOG, 'Object-status: noneDisabled =', noneDisabled, ', someEnabled =', someEnabled, '→ granted =', granted);
      applyShopifyConsent(granted);
    } else {
      console.log(LOG, 'Geen status beschikbaar — wachten op gebruikerskeuze');
    }
  }

  console.log(LOG, 'Script geladen, registreren Didomi listeners...');

  // Queue consent.changed listener — fires before AND after Didomi SDK loads
  window.didomiEventListeners = window.didomiEventListeners || [];
  window.didomiEventListeners.push({
    event: 'consent.changed',
    listener: function () {
      console.log(LOG, 'consent.changed event ontvangen, window.Didomi =', !!window.Didomi);
      if (window.Didomi) resolveConsent(window.Didomi);
    },
  });

  // On SDK ready: sync consent for returning visitors who already gave/denied consent
  window.didomiOnReady = window.didomiOnReady || [];
  window.didomiOnReady.push(function (Didomi) {
    console.log(LOG, 'didomiOnReady fired');
    resolveConsent(Didomi);
  });

  // Diagnostic: warn if Didomi never fires after 5 seconds
  setTimeout(function () {
    if (!window.Didomi) {
      console.error(LOG, 'Didomi SDK nog niet geladen na 5 seconden — cookiewall geblokkeerd of script niet ingeladen?');
    } else {
      console.log(LOG, 'Didomi SDK aanwezig na 5 seconden');
    }
  }, 5000);
})();
